// ---------------- FILTER PANEL ----------------

import React, { useEffect, useState } from "react";
import Icon from "../Icon/icon";

import Colors from "../../Styles/color.module.scss";
import { GradientButton } from "../Cta";
import { CustomSearchSelectBox } from "../FormElements";
import APIService from "../../Services/api-service";
import { toast } from "react-toastify";
// import CustomSearchSelectBox from "../CustomSearchSelectBox";


function getMonthYearOptions(startYear = 2015) {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // 1 = January

    const months = [
        { value: 1, label: "January" },
        { value: 2, label: "February" },
        { value: 3, label: "March" },
        { value: 4, label: "April" },
        { value: 5, label: "May" },
        { value: 6, label: "June" },
        { value: 7, label: "July" },
        { value: 8, label: "August" },
        { value: 9, label: "September" },
        { value: 10, label: "October" },
        { value: 11, label: "November" },
        { value: 12, label: "December" }
    ];

    const options = [];

    for (let year = currentYear; year >= startYear; year--) {
        const maxMonth = year === currentYear ? currentMonth : 12;

        for (let m = 1; m <= maxMonth; m++) {
            const month = months[m - 1];
            options.push({
                value: `${year}-${m.toString().padStart(2, "0")}`,
                label: `${month.label} ${year}`
            });
        }
    }

    return options;
}


const RevenueFilter = (props) => {

    const [monthMenuOpen, setMonthMenuOpen] = useState(false);
    const [monthOptions, setMonthOptions] = useState([]);
    const [tempMonth, setTempMonth] = useState(null);
    const [appliedFilters, setAppliedFilters] = useState({});
    const [zone, setZone] = useState(null);
    const [region, setRegion] = useState(null);
    const [month, setMonth] = useState();
    const [branch, setBranch] = useState(null);
    const [asset, setAsset] = useState(null);
    const [zoneFilter, setZoneFilter] = useState([]);


    useEffect(() => {
        _zoneFilter();
    }, []);


    const _applyFilters = (filters) => {
        console.log("Filters selected:", filters);
        // _revenueReport(filters);
        setAppliedFilters(filters);
        // setShowFilterPanel(false);
    };


    const handleZoneChange = (value) => {
        setZone(value);
        // _regionFilter(value.value);
    };

    const handleRegionChange = (value) => {
        setRegion(value);
        setBranch(null);
        // _branchFilter(value.value);
    };

    const handleClear = () => {
        setMonth(null);
        setZone(null);
        setRegion(null);
        setBranch(null);
        // setAdmin(null);
        setAsset(null);
        // setTransaction(null);
        // setTrunction(null);

        // onClear();
        // setShowFilterPanel(false);
        // _revenueReport();
        props.handleApply();
        props.filterPanel(false);
    };

    const handleApply = () => {
        const test = {
            zone: zone
        }
        props.filterPanel(false);
        props.handleApply(test);
        // onApplyFilter({ month, zone, region, branch, admin, asset, transaction, trunction });
    };

    const openMonthMenu = () => {
        setTempMonth(month);
        // setMonthMenuOpen(true);
    };

    const closeMonthMenu = () => {
        // setMonthMenuOpen(false);
    };

    const handleMonthRadioChange = (option) => {
        setTempMonth(option);
    };

    const applyMonthSelection = () => {
        setMonth(tempMonth);
        // setMonthMenuOpen(false);
    };


    const _zoneFilter = () => {
        let is_post = false;
        let url = 'client_mapping/zone/list';
        APIService(is_post, url).then((response) => {
            if (response.status_code === 200) {
                const mapped = response.data.map(zone => ({
                    // ...zone,
                    label: zone.name,
                    value: zone.id,   // FIXED
                }));
                setZoneFilter(mapped);
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
        })
    };


    return (
        <div className="bg-white border-radius-16px p-3 mb-4 e-filter-revenue" style={{ border: "1px solid #E0E0E0" }}>
            <p className="e-poppins-medium e-font-14 color-light-black line-height-18px mb-2">Filters</p>

            <div className="row g-3">
                <div className="col-lg-3 col-sm-6 position-relative">
                    {/* Control that looks like a select (bootstrap utility classes) */}
                    <div
                        className="month-select-control position-relative custom-select-box cursor-pointer"
                        onClick={(e) => { e.stopPropagation(); openMonthMenu(); }}
                    >

                        <div className={`d-flex align-items-center justify-content-between `}>

                            {
                                <span
                                    className={`color-outer-space e-poppins-regular e-report-filter-label  e-font-14 line-height-24px 
                                           bg-white `}
                                    data-valid={month?.value ? 'true' : 'false'}
                                >
                                    Month
                                </span>

                            }


                            <span className="e-poppins-medium color-charleston-green">
                                {month?.label ? month?.label : ''}
                            </span>


                            <span className="arrow-icon-report">
                                <Icon icon="right-arrow"
                                    width="20px"
                                    height="20px"
                                    className={monthMenuOpen ? 'dropdown-icon ' : `rotate-90deg`}
                                    color={Colors.space_cadet} />
                            </span>
                        </div>
                    </div>


                    {/* Backdrop + Popover (rendered when open) */}
                    {monthMenuOpen && (
                        <>
                            {/* backdrop */}
                            <div className="month-backdrop"
                                onClick={closeMonthMenu} />

                            {/* popover card */}
                            <div className="month-popover card">
                                <div className="card-body p-2 border-0">
                                    <h6 className="mb-0 e-poppins-medium e-font-14 line-height-18px color-black">Select month</h6>
                                </div>

                                <div className="month-list list-group list-group-flush">
                                    {monthOptions.map((opt) => (
                                        <label
                                            key={opt.value}
                                            className=" list-group-item-action d-flex align-items-center  month-option"
                                            onClick={() => handleMonthRadioChange(opt)}
                                        >
                                            {/* <input
                                                    type="radio"
                                                    name="month-radio"
                                                    checked={tempMonth?.value === opt.value}
                                                    readOnly
                                                    className="form-check-input "
                                                /> */}
                                            <Icon
                                                size={20}
                                                icon={tempMonth?.value === opt.value ? `radio-selected` : 'radio-unselected'}
                                            />
                                            <span className={tempMonth?.value === opt.value ? "e-poppins-medium" : "e-poppins-regular e-font-14 line-height-22px color-black"}>
                                                {opt.label}
                                            </span>
                                        </label>
                                    ))}
                                </div>

                                <div className="card-footer bg-white d-flex justify-content-end gap-2">

                                    <GradientButton label={"Apply"}
                                        disabled={!tempMonth}
                                        onPress={applyMonthSelection}
                                        className="me-2 border-radius-8px e-font-14 line-height-14px e-poppins-regular py-2 " />
                                </div>
                            </div>
                        </>
                    )}
                </div>


                <div className="col-lg-3 col-sm-6">
                    <CustomSearchSelectBox
                        label="Region"
                        options={zoneFilter}
                        value={zone}
                        onSelectChange={handleZoneChange}
                    />
                </div>

                {/*
                <div className="col-lg-3 col-sm-6">
                    <CustomSearchSelectBox
                        label="Zone"
                        options={regionFilter}
                        value={region}
                        isDisabled={!zone}
                        onSelectChange={handleRegionChange}
                    />
                </div>

                <div className="col-lg-3 col-sm-6">
                    <CustomSearchSelectBox
                        label="Branch"
                        options={branchFilter}
                        value={branch}
                        isDisabled={!region}
                        onSelectChange={setBranch}
                    />
                </div>

                <div className="col-lg-3 col-sm-6">
                    <CustomSearchSelectBox
                        label="Admin type"
                        options={adminType}
                        value={admin}
                        onSelectChange={setAdmin}
                    />
                </div>

                <div className="col-lg-3 col-sm-6">
                    <CustomSearchSelectBox
                        label="Asset type"
                        options={assetTypeFilter}
                        value={asset}
                        onSelectChange={setAsset}
                    />
                </div>

                <div className="col-lg-3 col-sm-6">
                    <CustomSearchSelectBox
                        label="Transaction type"
                        options={transactionTypeFilter}
                        value={transaction}
                        onSelectChange={setTransaction}
                    />
                </div>

                <div className="col-lg-3 col-sm-6">
                    <CustomSearchSelectBox
                        label="Sub truncation"
                        options={subTransactionTypeFilter}
                        value={trunction}
                        onSelectChange={setTrunction}
                    />
                </div> */}
            </div>

            <div className="d-flex justify-content-end gap-3 mt-4">
                <button className="border-radius-8px  e-poppins-regular e-font-14 line-height-14px  bg-transparent border-all border-primary-color px-3 py-2" onClick={handleClear}>Clear</button>
                <GradientButton label={"Apply filter"}
                    onPress={handleApply}
                    className="me-2 border-radius-8px e-font-14 line-height-14px e-poppins-regular padding-6px-tb " />
            </div>

        </div>
    );
};

export default RevenueFilter;
